/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Swiper Options Configuration
 * All swiper-related configuration following the generic plugin pattern
 */

/**
 * Default module options for Swiper
 * Applied when modules are enabled with boolean `true`
 */
export const SWIPER_MODULE_DEFAULTS = {
  /**
   * @link [Navigation](https://swiperjs.com/swiper-api#navigation)
   */
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  /**
   * @link [Pagination](https://swiperjs.com/swiper-api#pagination)
   */
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },

  /**
   * @link [Scrollbar](https://swiperjs.com/swiper-api#scrollbar)
   */
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
  },

  /**
   * @link [Autoplay](https://swiperjs.com/swiper-api#autoplay)
   */
  autoplay: {
    delay: 5000,
    pauseOnMouseEnter: true,
  },
};

/**
 * Swiper options presets
 * @link [Swiper API](https://swiperjs.com/swiper-api#parameters)
 */
export const SWIPER_OPTIONS = {
  /**
   * Default options - always applied
   */
  default: {
    navigation: true,
    pagination: false,
    scrollbar: false,
    autoHeight: true,
    spaceBetween: 0,
    effect: 'slide',
    loopAddBlankSlides: false,
    slidesPerView: 4,
    slidesPerGroup: 4,
  },

  /**
   * Autoplay preset
   */
  autoplay: {
    autoplay: {...SWIPER_MODULE_DEFAULTS.autoplay},
  },

  /**
   * Gallery preset
   */
  product_gallery: {
    slidesPerView: 1,
    effect: 'slide',
    navigation: true,
    pagination: true,
  },

  /**
   * Products preset (for ProductSwiper)
   */
  products: {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 20,
  },

  /**
   * Contents preset (for ContentSwiper)
   */
  contents: {
    autoHeight: false,
  },

  /**
   * Thumbnails preset
   */
  thumbnails: {
    slidesPerView: 6,
    spaceBetween: 10,
    navigation: false,
    pagination: false,
  },
};
